import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useProfileStore } from '@/stores/RootStore';

import routePaths from './routePaths';

function AuthenticatedRoute({ children }: PropsWithChildren) {
  const profileStore = useProfileStore();

  if (!profileStore.profile?.id) {
    return <Navigate to={routePaths.root} replace />;
  }

  return <>{children}</>;
}

export default observer(AuthenticatedRoute);
